/**
 * UI Constants for the Case Management Application
 */
export const UI_CONSTANTS = {
  LOGO: {
    SRC: "/OPCS_Logo.webp",
    ALT: "OP Logo",
    FILTER: { filter: 'brightness(1.1) contrast(1.1)' },
    CONTAINER_WIDTH: "w-96",
    CONTAINER_HEIGHT: "h-20"
  },
  HEADER: {
    PADDING: "p-2",
    TITLE: "CaseTrac"
  },
  TABLE: {
    COLUMN_COUNT: 7
  }
} as const;

/**
 * Utility functions for styling
 */
export const getOrganColor = (organ: string): string => {
  const colorMap: Record<string, string> = {
    'Kidney': 'bg-blue-100 text-blue-800',
    'Liver': 'bg-red-100 text-red-800',
    'Heart': 'bg-pink-100 text-pink-800',
    'Lung': 'bg-purple-100 text-purple-800'
  };
  return colorMap[organ] || 'bg-gray-100 text-gray-800';
};

export const getDispositionColor = (disposition: string): string => {
  const colorMap: Record<string, string> = {
    'Transplanted': 'bg-emerald-100 text-emerald-800',
    'Research': 'bg-blue-100 text-blue-800',
    'Discarded': 'bg-red-100 text-red-800'
  };
  return colorMap[disposition] || 'bg-gray-100 text-gray-800';
};

/**
 * Error handling utility
 */
// Lightweight global toast bridge (avoids prop drilling).
type Listener = (payload: { message: string; type: 'success' | 'error' | 'info' | 'warning'; duration?: number }) => void;
const toastListeners = new Set<Listener>();
export const __subscribeToToasts = (fn: Listener) => {
  toastListeners.add(fn);
  return () => { toastListeners.delete(fn); };
};
const emitToast = (message: string, type: 'success' | 'error' | 'info' | 'warning', duration?: number) => {
  for (const fn of toastListeners) fn({ message, type, duration });
};

export const showErrorNotification = (message: string, duration?: number): void => {
  emitToast(message, 'error', duration || 5000); // Errors stay longer by default
};

export const showSuccessNotification = (message: string, duration?: number): void => {
  emitToast(message, 'success', duration || 3500);
};

export const showInfoNotification = (message: string, duration?: number): void => {
  emitToast(message, 'info', duration || 3500);
};

export const showWarningNotification = (message: string, duration?: number): void => {
  emitToast(message, 'warning', duration || 4000);
};
